/**
 * @module components\Shared\PageNotFound
*/
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class PageNotFound extends Vue {
    
}